import { IResult } from '../types/IResponse';
import { DisplayMode } from '../types/ISessionInfo';
import { Request } from './Request';

export interface IUpdateDisplayModeParams {
  displayMode: DisplayMode;
}

export class UpdateDisplayModeRequest extends Request<IUpdateDisplayModeParams, IResult> {
  constructor(params: IUpdateDisplayModeParams) {
    super('updateDisplayMode', params);
  }
}
